import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const remarkResource = '/merchant/order'

// const defaultPagination = 10

export default {
  getRemarkList(id) {
    return Repository.get(`${remarkResource}/${id}/remark`)
  },
  createRemark(id, payload) {
    return OperationRepository.post(`${remarkResource}/${id}/remark`, payload)
  },
  updateRemark(id, remarkId, payload) {
    return OperationRepository.put(`${remarkResource}/${id}/remark/${remarkId}`, payload)
  },
  deleteRemark(id) {
    return Repository.delete(`${remarkResource}/remark/${id}`)
  },
  markAsRead(id) {
    return Repository.post(`${remarkResource}/${id}/remark/mark-as-read`)
  },
}
